import type { RawTab } from '../../types';

import * as shared from './shared';

export const StoreLocatorTab: RawTab = {
  id: shared.id,

  link: shared.link,

  iconSource: require('./icons/fhs-store-locator-inactive.png'),
  iconActiveSource: require('./icons/fhs-store-locator-active.png'),

  text: {
    en: 'Location',
    // @TODO: french text
    fr: 'Location',
  },
};
